/* Open chat under the end screen's title when Telegram refused the confirmation (phone-booked.html frame B, .tw-openChat). */
.openChat {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(var(--accent-rgb), 0.45);
  color: var(--accent);
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}
